import React from 'react';
import Wrapper from '../../assets/wrappers/MediaGalleryWrapper'; // השתמש ב-Wrapper המתאים
import MediaCard from './MediaCard';

const MediaContainer = ({ media, onDelete }) => {
  // חלוקת המדיה לקטגוריות תמונות וסרטונים
  const images = media.filter((item) => item.mediaType === 'image');
  const videos = media.filter((item) => item.mediaType === 'video');
  
  if (media.length === 0) {
    return (
      <Wrapper>
        <h2>לא נמצאה מדיה להציג...</h2>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {/* קטגוריית תמונות */}
      <h4>תמונות ({images.length})</h4>
      <div className='media-gallery'>
        {images.map((image) => (
          <MediaCard key={image._id} media={image} onDelete={onDelete} />
        ))}
      </div>

      <h4>סרטונים ({videos.length})</h4>
      <div className='media-gallery'>
        {videos.map((video) => (
          <MediaCard key={video._id} media={video} onDelete={onDelete} /> 
        ))}
      </div>
    </Wrapper>
  );
};

export default MediaContainer;
